import { FC } from "react";

interface ExportIconProps {
    color?: string;
}
export const ExportIcon: FC<ExportIconProps> = ({ color = 'white' }) => {
    return <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4199 2.4082C6.21198 2.4082 2.79688 5.82331 2.79688 10.0312C2.79688 14.2391 6.21198 17.6542 10.4199 17.6542C14.6278 17.6542 18.0429 14.2391 18.0429 10.0312" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.1875 9.26844L17.4384 3.01758" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18.0413 6.09012V2.4082H14.3594" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

}